import { TranslateService } from "@ngx-translate/core";
import { MessagePortalComponent } from "src/app/portal/portal";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { slideDownUp, toggleAnimation } from "src/app/shared/animations";
import { PositioningService } from "src/app/shared/services/positioning.service";
import { DatatableColumn } from "../../../shared/components/base-table/base-table.component";
import { TempestUser } from "src/app/auth/model/user";
import { UserService } from "../service/user.service";
import Swal from "sweetalert2";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { PopupType } from "src/app/shared/enums/popup-types";

@Component({
  selector: "app-contract-users-table",
  templateUrl: "./contract-users.table.component.html",
  animations: [slideDownUp, toggleAnimation],
  standalone: false,
})
export class ContractUsersTableComponent implements OnInit {
  @Input() apiKey: string = "";

  @ViewChild("dropdownPlaceholder") dropdownPlaceholder!: ElementRef;
  @ViewChild(MessagePortalComponent) messagePortalComponent!: MessagePortalComponent;

  isLoading = false;
  items: TempestUser[] = [];
  cols!: DatatableColumn[];

  constructor(
    private translate: TranslateService,
    private positioningService: PositioningService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.loadUsers();
  }

  loadUsers() {
    this.isLoading = true;
    const subscription = this.userService.getContractUsers(this.apiKey).subscribe((response) => {
      subscription.unsubscribe();
      this.isLoading = false;
      this.items = response;
    });
  }

  getColumns(): void {
    this.translate.get(["contract.actions", "contract.apiKey"]).subscribe((translations) => {
      this.cols = [
        ...(!this.apiKey ? [{ field: "apiKey", title: translations["contract.apiKey"] } as DatatableColumn] : []),
        { field: "email", title: "Email" } as DatatableColumn,
        { field: "tAId", title: "TA Id" } as DatatableColumn,
        { field: "zephyrId", title: "Zephyr Id" } as DatatableColumn,
        ...(!this.apiKey ? [{ field: "actions", title: translations["contract.actions"] } as DatatableColumn] : []),
      ];
    });
  }

  openDeleteModal(email: string, apiKey: string) {
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("users_page.confirm_delete"),
      showCancelButton: true,
      confirmButtonText: this.translate.instant("Yes"),
      cancelButtonText: this.translate.instant("No"),
      customClass: {
        confirmButton: "swal2-confirm btn btn-primary",
        cancelButton: "swal2-cancel btn btn-secondary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        const deleteSub = this.userService.deleteInstanceUser(email, apiKey).subscribe({
          next: () => {
            deleteSub.unsubscribe();
            this.isLoading = false;
            showMessage(PopupType.Success, this.translate.instant("users_page.successfull_delete"));
            this.loadUsers();
          },
          error: () => {
            deleteSub.unsubscribe();
            this.isLoading = false;
            showMessage(PopupType.Danger, this.translate.instant("users_page.invalid_delete"));
          },
        });
      }
    });
  }

  onPortalAttached() {
    setTimeout(() => {
      this.positioningService.setPosition(this.dropdownPlaceholder, this.messagePortalComponent);
    }, 0);
  }
}
